import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 relative overflow-hidden" data-id="element-55">
      {/* Metallic Background */}
      <div className="absolute inset-0 metallic-gradient opacity-20" data-id="element-56" />
      <div className="absolute inset-0 bg-blueprint opacity-30 mix-blend-overlay" data-id="element-57" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0D1117] via-transparent to-[#0D1117]" data-id="element-58" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto text-center glass-panel rounded-3xl p-12 md:p-20 border-white/20 shadow-[0_0_50px_rgba(192,192,192,0.1)]" data-id="element-60">
          <h2 className="text-4xl md:text-6xl font-bold font-heading mb-8 metallic-text" data-id="element-61">
            Tu próximo proyecto comienza hoy
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-62">
            La diferencia entre improvisar y construir profesionalmente comienza
            con el conocimiento correcto.
          </p>

          <a href="#oferta" className="inline-flex items-center justify-center gap-3 bg-[#2F80ED] hover:bg-[#2563EB] text-white px-10 py-5 rounded-2xl font-bold text-xl transition-all blue-glow hover:scale-105" data-id="element-63">
            <Download className="w-6 h-6" data-id="element-64" />
            DESCARGAR COLECCIÓN COMPLETA
          </a>
        </motion.div>
      </div>
    </section>;
}